







































































import {Component} from '@/shared/component';
import {Commande} from '@/models';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';

import storeCommande from '@/stores/modules/commande';

import CrudFournisseurShow from '@/components/Crud/Fournisseur/Show.vue';
import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurShow,
		CrudFournisseurEdit,
	}
})
export default class CrudCommandeShow extends AbstractShowVue<Commande> {
	public constructor() {
		super(storeCommande);
	}
}
